// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import device from './device.svg';

interface DeviceIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: DeviceNames;
}

export function DeviceIcon({ name, ...props }: DeviceIconProps) {
  return <Icon {...props} link={device} name={name} />
}

type DeviceNames =
  | '1x_mobiledata'
  | '30fps'
  | '3g_mobiledata'
  | '4g_mobiledata'
  | '4g_plus_mobiledata'
  | '60fps'
  | 'access_alarm'
  | 'access_alarms'
  | 'access_time_filled'
  | 'access_time'
  | 'ad_units'
  | 'add_alarm'
  | 'add_to_home_screen'
  | 'air'
  | 'airplane_ticket'
  | 'airplanemode_active'
  | 'airplanemode_inactive'
  | 'aod'
  | 'battery_0_bar'
  | 'battery_1_bar'
  | 'battery_2_bar'
  | 'battery_3_bar'
  | 'battery_4_bar'
  | 'battery_5_bar'
  | 'battery_6_bar'
  | 'battery_alert'
  | 'battery_charging_full'
  | 'battery_full'
  | 'battery_saver'
  | 'battery_std'
  | 'battery_unknown'
  | 'bloodtype'
  | 'bluetooth_connected'
  | 'bluetooth_disabled'
  | 'bluetooth_drive'
  | 'bluetooth_searching'
  | 'bluetooth'
  | 'brightness_auto'
  | 'brightness_high'
  | 'brightness_low'
  | 'brightness_medium'
  | 'cable'
  | 'cameraswitch'
  | 'credit_score'
  | 'dark_mode'
  | 'data_saver_off'
  | 'data_saver_on'
  | 'data_usage'
  | 'developer_mode'
  | 'device_thermostat'
  | 'devices_fold'
  | 'devices'
  | 'discount'
  | 'do_not_disturb_on_total_silence'
  | 'dvr'
  | 'e_mobiledata'
  | 'edgesensor_high'
  | 'edgesensor_low'
  | 'flashlight_off'
  | 'flashlight_on'
  | 'flourescent'
  | 'fmd_bad'
  | 'fmd_good'
  | 'g_mobiledata'
  | 'gpp_bad'
  | 'gpp_good'
  | 'gpp_maybe'
  | 'gps_fixed'
  | 'gps_not_fixed'
  | 'gps_off'
  | 'graphic_eq'
  | 'grid_3x3'
  | 'grid_4x4'
  | 'grid_goldenratio'
  | 'h_mobiledata'
  | 'h_plus_mobiledata'
  | 'hdr_auto_select'
  | 'hdr_auto'
  | 'hdr_off_select'
  | 'hdr_on_select'
  | 'lan'
  | 'lens_blur'
  | 'light_mode'
  | 'location_disabled'
  | 'location_searching'
  | 'lte_mobiledata'
  | 'lte_plus_mobiledata'
  | 'media_bluetooth_off'
  | 'media_bluetooth_on'
  | 'medication_liquid'
  | 'medication'
  | 'mobile_friendly'
  | 'mobile_off'
  | 'mobiledata_off'
  | 'mode_night'
  | 'mode_standby'
  | 'monitor_heart'
  | 'monitor_weight'
  | 'nearby_error'
  | 'nearby_off'
  | 'network_cell'
  | 'network_wifi_1_bar'
  | 'network_wifi_2_bar'
  | 'network_wifi_3_bar'
  | 'network_wifi'
  | 'nfc'
  | 'nightlight'
  | 'note_alt'
  | 'password'
  | 'pattern'
  | 'phishing'
  | 'pin'
  | 'play_lesson'
  | 'price_change'
  | 'price_check'
  | 'punch_clock'
  | 'quiz'
  | 'r_mobiledata'
  | 'radar'
  | 'remember_me'
  | 'reset_tv'
  | 'restart_alt'
  | 'reviews'
  | 'rsvp'
  | 'screen_lock_landscape'
  | 'screen_lock_portrait'
  | 'screen_lock_rotation'
  | 'screen_rotation'
  | 'screen_search_desktop'
  | 'screenshot_monitor'
  | 'screenshot'
  | 'sd_storage'
  | 'security_update_good'
  | 'security_update_warning'
  | 'security_update'
  | 'sell'
  | 'send_to_mobile'
  | 'settings_suggest'
  | 'settings_system_daydream'
  | 'share_location'
  | 'shortcut'
  | 'signal_cellular_0_bar'
  | 'signal_cellular_4_bar'
  | 'signal_cellular_alt_1_bar'
  | 'signal_cellular_alt_2_bar'
  | 'signal_cellular_alt'
  | 'signal_cellular_connected_no_internet_0_bar'
  | 'signal_cellular_connected_no_internet_4_bar'
  | 'signal_cellular_no_sim'
  | 'signal_cellular_nodata'
  | 'signal_cellular_null'
  | 'signal_cellular_off'
  | 'signal_wifi_0_bar'
  | 'signal_wifi_4_bar_lock'
  | 'signal_wifi_4_bar'
  | 'signal_wifi_bad'
  | 'signal_wifi_connected_no_internet_4'
  | 'signal_wifi_off'
  | 'signal_wifi_statusbar_4_bar'
  | 'signal_wifi_statusbar_connected_no_internet_4'
  | 'signal_wifi_statusbar_null'
  | 'sim_card_download'
  | 'splitscreen'
  | 'sports_score'
  | 'ssid_chart'
  | 'storage'
  | 'storm'
  | 'summarize'
  | 'system_security_update_good'
  | 'system_security_update_warning'
  | 'system_security_update'
  | 'task_outline'
  | 'task'
  | 'thermostat'
  | 'timer_10_select'
  | 'timer_3_select'
  | 'tungsten'
  | 'usb_off'
  | 'usb'
  | 'wallpaper'
  | 'water'
  | 'widgets'
  | 'wifi_1_bar'
  | 'wifi_2_bar'
  | 'wifi_calling_3'
  | 'wifi_channel'
  | 'wifi_find'
  | 'wifi_lock'
  | 'wifi_password'
  | 'wifi_tethering_error'
  | 'wifi_tethering_off'
  | 'wifi_tethering'
;

